export default __webpack_public_path__ + "static/media/rock-bg.3f40652a.png";